<template>
  <div class="after-sale-video-detail" v-if="tableData.length > 0">
    <template v-for="project in tableData" :key="project.id">
      <div class="wrapper after-sale-back">
        <div class="wrapper-text">
          <span>{{ project.title }}</span>
        </div>

        <div class="wrapper-subtext">
          <span>{{ project.notes }}</span>
        </div>

        <img :src="product.poster" alt="" :class="product.imgclass" />
      </div>

      <div class="wrapper wrapper-list">
        <div v-for="videoInfo in project.children" :key="videoInfo.name" class="card">
          <div class="tiitle">{{ videoInfo.title }}</div>
          <div
            v-for="(video, index) in videoInfo.children"
            :key="video.filePath"
            @click="toVideo(video.filePath)"
            class="info df"
          >
            <img :src="product.list[index % 2]" alt="" />

            <img src="@/assets/img/page/after-sale-wan-start.png" class="start-img" alt="" />

            <div class="sub-title">
              {{ video.title }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { computed, defineComponent, onActivated } from "vue";
import { videoList } from "./data";
import { getProductVideoList } from "@/request/view/afterSale.js";
import { useRoute, useRouter } from "vue-router";
import { reactive } from "vue";

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();

    const videoDetail = computed(() => {
      return videoList.filter((f) => f.name === route.query.type)[0];
    });

    const productOption = {
      "光学生物测量仪(天鹅)": {
        imgclass: "swan",
        seriesName: "Swan系列",
        list: [
          require(`../../../assets/img/page/after-sale-swan-0.png`),
          require(`../../../assets/img/page/after-sale-swan-1.png`),
        ],
        poster: require("../../../assets/img/page/after_sale_swan.png"),
      },
      "视力筛查仪(天鸽)": {
        imgclass: "columba",
        seriesName: "Columba系列",
        list: [
          require(`../../../assets/img/page/after-sale-columba-0.png`),
          require(`../../../assets/img/page/after-sale-columba-1.png`),
        ],
        poster: require("../../../assets/img/page/after_sale_columba.png"),
      },
      "Optic Biometer  Swan": {
        imgclass: "swan",
        seriesName: "Swan系列",
        list: [
          require(`../../../assets/img/page/after-sale-swan-0.png`),
          require(`../../../assets/img/page/after-sale-swan-1.png`),
        ],
        poster: require("../../../assets/img/page/after_sale_swan.png"),
      },
      "Vision Screener Columba": {
        imgclass: "columba",
        seriesName: "Columba系列",
        list: [
          require(`../../../assets/img/page/after-sale-columba-0.png`),
          require(`../../../assets/img/page/after-sale-columba-1.png`),
        ],
        poster: require("../../../assets/img/page/after_sale_columba.png"),
      },
      "视功能检查训练仪(星豚)": {
        imgclass: "starton",
        seriesName: "Starton系列",
        list: [
          require(`../../../assets/img/page/after_sale_starton-0.png`),
          require(`../../../assets/img/page/after_sale_starton-1.png`),
        ],
        poster: require("../../../assets/img/page/after_sale_starton.png"),
      },
      "功能镜片检测仪(天猫)": {
        imgclass: "lynx",
        seriesName: "Lynx系列",
        list: [
          require(`../../../assets/img/page/after-sale-lynx-0.png`),
          require(`../../../assets/img/page/after-sale-lynx-1.png`),
        ],
        poster: require("../../../assets/img/page/after_sale_lynx.png"),
      },
    };

    const product = computed(() => {
      if (!productOption[route.query.type]) return {list: [], poster: ''};

      return productOption[route.query.type];
    });

    const toVideo = (url) => {
      router.push(`/aftersalelookvideo?videourl=${url}`);
    };

    const tableData = reactive([]);

    const getVideoData = () => {
      tableData.length = 0;
      getProductVideoList({
        productType: route.query.productType,
      })
        .then((res) => {
          if (res.code === 200 && res.data && res.data.length > 0) {
            tableData.push(...res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    onActivated(() => {
      document.title = route.query.type;
      getVideoData();
    });

    return {
      product,
      tableData,
      videoDetail,
      toVideo,
    };
  },
});
</script>

<style lang="less" scoped>
.after-sale-video-detail {
  overflow-y: scroll;
  background: #f7f8fb;
  height: 100vh;

  .wrapper {
    padding: 0 0.30998rem;
  }

  .after-sale-back {
    width: 100%;
    height: 5.45rem;
    background: url("../../../assets/img/page/after_sale_machine.png");
    background-size: 100% 100%;
    position: relative;
    padding-top: 0.62rem;

    h1 {
      font-size: 0.45999rem;
      color: #ffffff;
      line-height: 0.55999rem;
      text-align: center;
    }

    img {
      width: 3.28001rem;
      height: 2.86999rem;
      position: absolute;
      right: 0.51001rem;
      top: 0.1rem;
    }

    .columba {
      width: 3.99001rem;
      height: 2.70999rem;
      right: 0.39998rem;
      bottom: 2.65001rem;
    }

    .wrapper-text {
      font-size: 0.50001rem;
      color: #ffffff;
      margin-bottom: 0.12998rem;
    }

    .wrapper-subtext {
      font-size: 0.30998rem;
      color: #ffffff;

      span {
        margin-right: 0.19999rem;
      }
    }
  }

  .wrapper-list {
    margin-top: -2.35998rem;
    position: relative;
    z-index: 1;

    .card {
      background: #ffffff;
      box-shadow: 0rem 0.1rem 0.1rem 0rem #f0f4f9;
      border-radius: 0.15001rem;
      margin-bottom: 0.30998rem;
      padding: 0.30998rem;

      .tiitle {
        font-size: 14px;
        letter-spacing: 2px;
        font-weight: bold;
        border-bottom: 2px solid #f2f2f2;
        padding-bottom: 0.30998rem;
        margin-bottom: 10px;
      }

      .info {
        margin-bottom: 0.30998rem;
        position: relative;

        img {
          width: 2.25999rem;
          height: 1.85001rem;
          margin-right: 10px;
        }

        .start-img {
          width: 0.63999rem;
          height: 0.63999rem;
          position: absolute;
          left: 0.81rem;
          top: 0.60001rem;
        }

        .sub-title {
          padding-top: 0.20999rem;
          font-weight: 400;
          font-size: 0.41001rem;
          color: #333333;
        }
      }
    }
  }
}
</style>
